import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { UserService } from '../services/user.service';
import { NotificationsService } from 'angular2-notifications';

const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-addeditsubmenu',
    templateUrl: './addeditsubmenu.component.html',
    styleUrls: ['./addeditsubmenu.component.css']
})
export class AddEditSubmenuComponent implements OnInit {
    subMenuForm: FormGroup;
    parentMenus: any;
    groups: any[] = [];
    dropdownSettings = {};
    selectedItems: any = [];
    selectedItemIds: string[] = [];
    parentMenusCopy: any[] = [];
    parentMenuId: any;
    constructor(
        public dialogRef: MatDialogRef<AddEditSubmenuComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public fb: FormBuilder,
        public userService: UserService,
        public notifSer: NotificationsService
    ) { }

    async ngOnInit() {
        this.subMenuForm = this.fb.group({
            parent_menu: ['', Validators.required],
            sub_menu: ['', Validators.required],
            menu_url: ['', Validators.required],
            groupIds: [''],
            is_active: [''],
            order: ['', Validators.min(0)],
        });
        this.getParentMenu();
        await this.getGroups();

        this.dropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'group',
            text: 'Select Groups',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 1,
            enableSearchFilter: true,
            classes: 'myclass custom-class'
        };

    }
    onItemSelect(item: any) {
        this.selectedItemIds.push(item.id);
        // Update the form control value
        this.subMenuForm.get('groupIds').setValue(this.selectedItemIds);
    }
    OnItemDeSelect(item: any) {
        // Remove the deselected item's ID from selectedItemIds
        this.selectedItemIds = this.selectedItemIds.filter(id => id !== item.id);
        // Update the form control value
        this.subMenuForm.get('groupIds').setValue(this.selectedItemIds);
    }
    onSelectAll(items: any) {
        console.log(items);
    }
    onDeSelectAll(items: any) {
        console.log(items);
    }
    getGroups() {
        this.userService.getGroups().subscribe(groups => {
            this.groups = groups.map(item => {
                return {
                    id: item._id,
                    itemName: item.group
                }
            });
        })
    }
    getParentMenu() {
        this.userService.getAdminParentMenus().subscribe(menus => {
            // Load the list before setting the selected id so parentMenuName can resolve it.
            this.parentMenus = menus;
            this.parentMenusCopy = menus;
            if (this.data && this.data.parent_menu) {
                const parentMenu = menus.find(menu => menu.menu === this.data.parent_menu);
                if (parentMenu) this.parentMenuId = parentMenu._id;
            }
        })
    }
    // The form stores the parent menu's _id; show its name in the input instead.
    parentMenuName = (id: any): string => {
        const parentMenu = (this.parentMenusCopy || []).find(menu => menu._id === id);
        return parentMenu ? parentMenu.menu : (id || '');
    }
    onOptionSelected() {

    }
    parentMenuFilter(event: any) {
        let term = event || '';
        // Picking an option sets the value to its _id; keep the full list in that case.
        if (this.parentMenusCopy.some(menu => menu._id === term)) {
            this.parentMenus = this.parentMenusCopy;
            return;
        }
        this.parentMenus = this.parentMenusCopy.filter(function (tag) {
            if (tag.menu.toLowerCase().indexOf(term.toLowerCase()) >= 0 || tag.menu.toLowerCase().indexOf(term.toLowerCase()) >= 0) {
                return tag;
            }
        });
    }

    saveSubmenu() {
        const { notif } = defaults;
        try {
            if (this.subMenuForm.valid) {
                this.userService.csrf().subscribe(success => {
                    this.subMenuForm.value['_csrf'] = success['_csrf'];
                    this.subMenuForm.value['_id'] = this.data._id;
                    this.userService.saveSubmenu(this.subMenuForm.value).subscribe(response => {
                        if (response.status) {
                            this.notifSer.success('Success', response.message, notif)
                            // Emit the form data when closing the dialog

                            this.dialogRef.close({ success: true, data: response.message });

                        } else this.notifSer.error('Error', response.message, notif);
                    }, err => this.notifSer.error('Error', err.error.message, notif))
                })
            }
        } catch (error) {

        }
    }
}


// WEBPACK FOOTER //
// ./src/app/addeditsubmenu/addeditsubmenu.component.ts